<template lang="pug">
    div.button-return(@click="prevStep")
      font-awesome-icon.button-return-icon(icon="angle-double-left")
      span Regresar
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ButtonReturn',
  computed: {
    ...mapGetters(['currentGroup', 'currentStep'])
  },
  props: {        
    onlyFather: {
      type: Boolean,
      default: false
    }    
  },
  methods: {
    ...mapMutations(['setCurrentGroup', 'setCurrentStep']),
    prevStep() {        
      if(this.currentStep.index > 0) {
        const step = this.currentGroup.steps[this.currentStep.index - 1];
        step.transition = 'scroll-slide-back';
        if(this.onlyFather === false) {
          this.setCurrentStep(step);
        }
        
        this.$emit('prev');
      }
    }
  }
}
</script>

<style scoped>
@import 'button-return.scss';
</style>

